module.exports = __webpack_public_path__ + "img/activity.b93fa3ea.png";